module.exports = __webpack_public_path__ + "media/double.006eac68.mp4";